import { PATH_SIGNUP } from '@farmersdog/constants/paths';
import { ResponsiveText } from '@farmersdog/corgi-legacy';
import { GridContainer, Link } from '@farmersdog/corgi-x';

import { TextTypeRenderer } from '../../components/TextTypeRenderer';
import {
  SliceType,
  EmailFormSlice,
  MetadataSlice,
  isSliceOfType,
} from '../../slices';

import styles from './BreedsContentType.css';
import { BreedsLinks } from './BreedsLinks';

import type { BreedsDocument } from './types';

export interface BreedsContentTypeProps {
  document: BreedsDocument;
}

export function BreedsContentType({ document }: BreedsContentTypeProps) {
  const emailFormSlice = document.data.body.find(
    isSliceOfType(SliceType.EmailFormSlice)
  );

  const metadataSlice = document.data.body.find(
    isSliceOfType(SliceType.MetadataSlice)
  );

  return (
    <>
      {metadataSlice && <MetadataSlice slice={metadataSlice} />}
      <GridContainer className={styles.grid}>
        <div className={styles.top}>
          <ResponsiveText
            className={styles.heading}
            as="h1"
            variant="heading-2"
            color="kale-3"
          >
            {document.data.h1}
          </ResponsiveText>
        </div>
        <div className={styles.left}>
          <ResponsiveText as="p" variant="article-1" color="charcoal-3">
            Our fresh recipes are good for dogs of all shapes, sizes, and
            breeds—from puppies to seniors. Below, you’ll find helpful info and
            care tips for a long roster of breeds. Even if you don’t see your
            dog’s breed—or breed mix—on the list, we make complete and balanced
            food for them. <Link href={PATH_SIGNUP}>Sign up here</Link> to start
            feeding fresh.
          </ResponsiveText>
          <TextTypeRenderer nodes={document.data.description} />
          <BreedsLinks />
        </div>
        <div className={styles.right}>
          {emailFormSlice && <EmailFormSlice slice={emailFormSlice} />}
        </div>
      </GridContainer>
    </>
  );
}
